import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import RecordRow from 'components/RecordRow';
import Spacing from 'components/Spacing';
import { FC } from 'react';
import {
  formatSnippet,
  formatAmlTypes,
  sanitizeAmlData,
} from 'helpers/kyc/text-formatting';
import SanitizedHitDataDisplay from './SanitizedHitDataDisplay';
import { dateToLabel } from 'further-ui/utils';

const StyledDiv = styled('div')({
  padding: '0px',
  maxWidth: '70vw',
  overflowX: 'auto',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
});

const StyledSpacing = styled(Spacing)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  cursor: 'pointer',
}));

type Props = {
  entity: {
    name: string;
    source: string;
    url: string;
    aml_types: Array<string>;
    data: Array<{ name: string; value: string }>;
    snippet?: string;
    published?: string;
  };
  index: number;
  type: string;
};

const AmlDetailItem: FC<Props> = ({ entity, index, type }) => {
  const processedData = sanitizeAmlData(entity.data);

  return (
    <StyledDiv key={`${type}-${index}`}>
      <Spacing size="sm">
        <Typography variant="h6">
          {formatAmlTypes(entity.aml_types).join(', ')}
        </Typography>

        <StyledSpacing size="sm">
          <RecordRow label="Title:" boldValue={false}>
            <StyledLink
              href={entity.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {entity.name}
            </StyledLink>
          </RecordRow>

          {type === 'adverse-media' && (
            <RecordRow label="Published:" boldValue={false}>
              {dateToLabel(
                entity.published,
                '(No date)',
                false,
                false,
                'do MMMM yyyy',
              )}
            </RecordRow>
          )}

          {entity.snippet && (
            <RecordRow label="Excerpt:" boldValue={false}>
              {formatSnippet(entity.snippet)}
            </RecordRow>
          )}

          <SanitizedHitDataDisplay
            data={processedData}
            type={type}
            index={index}
          />
        </StyledSpacing>
      </Spacing>
    </StyledDiv>
  );
};

export default AmlDetailItem;
